import { React } from '@gasbuddy/react';

export const Unknown = () => <h1>Route not yet implemented</h1>;
